export default "__VITE_ASSET__98bdda5c__"